import ConsultarManifestacoes from "@/views/administracao/ouvidoria/ConsultarManifestacoes.vue";
import VisualizaManifestacao from "@/views/administracao/ouvidoria/VisualizaManifestacao.vue";

const ouvidoriaRotas = [
  {
    path: "/administracao/ouvidoria/consultar-manifestacoes",
    name: "administracao--consultar-manifestacoes",
    component: ConsultarManifestacoes,
  },
  {
    path: "/administracao/ouvidoria/visualiza-manifestacao/:idManifestacao",
    name: "administracao--visualiza-manifestacao",
    component: VisualizaManifestacao,
    props: true,
  },
];

export { ouvidoriaRotas };
